module.exports = __webpack_public_path__ + "img/result_bing.cfcc44ad.jpg";